import React, { useCallback, useRef } from 'react';
import { Field, Form, Formik, FormikProps } from 'formik';
import ModalPopup from 'components/ModalPopup';
import Input from 'components/Input/Input';
import Button from 'components/Button/Button';
import { object } from 'yup';
import { t } from 'utils';
import styles from './ReloginPopup.module.scss';

const INITIAL_VALUES = { email: '', plainPassword: '' };

type ReloginPopupProps = {
    visible?: boolean;
    onLogin: (values: typeof INITIAL_VALUES & { client: string }) => void;
};

const validationSchema = () => object().shape({});

type SubmitHandler = {
    handleSubmit: () => void;
};

type FormRef = FormikProps<typeof INITIAL_VALUES> & SubmitHandler;

type WithClient = {
    client: { id: string };
};

const doNothing = () => null;

export default function ReloginPopup(props: ReloginPopupProps) {
    const { visible, onLogin } = props;
    const formRef = useRef<FormRef>(null);

    const handleSubmit = useCallback(
        values => {
            const pm2app = window.pm2app as unknown as WithClient;
            onLogin({ ...values, client: pm2app.client.id });
        },
        [onLogin]
    );

    const onSubmit = useCallback(() => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    }, []);

    return (
        <ModalPopup.Popup show={visible} onClose={doNothing}>
            <ModalPopup.Header className={styles.header} icon="info" titleClassName={styles.headerTitle}>
                {t('authentication.user._login.you_logged_out')}
            </ModalPopup.Header>
            <ModalPopup.Content>
                <p className={styles.p}>{t('authentication.user._login.login_to_continue')}</p>
                <Formik
                    initialValues={INITIAL_VALUES}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    innerRef={formRef}
                >
                    {() => (
                        <Form className="static-box-form">
                            <Field
                                name="email"
                                type="text"
                                component={Input}
                                label={t('authentication.user._login.email')}
                                labelWidth={Input.LABEL_WIDTH.HALF}
                                classNameInputWrapper={styles.Field}
                                classNameLabel={styles.label}
                            />
                            <Field
                                name="plainPassword"
                                type="password"
                                component={Input}
                                label={t('authentication.user._login.password')}
                                labelWidth={Input.LABEL_WIDTH.HALF}
                                classNameInputWrapper={styles.Field}
                                classNameLabel={styles.label}
                                rootClassName={styles.passwordRow}
                            />
                        </Form>
                    )}
                </Formik>
            </ModalPopup.Content>
            <ModalPopup.Actions hideCancel>
                <Button icon="save-exit" color={Button.COLOR.PRIMARY} small onClick={onSubmit} rightIcon>
                    {t('authentication.user._login.login')}
                </Button>
            </ModalPopup.Actions>
        </ModalPopup.Popup>
    );
}
